import { render } from "./SiteECommerce.vue?vue&type=template&id=876c5070"
import script from "./SiteECommerce.vue?vue&type=script&lang=js"
export * from "./SiteECommerce.vue?vue&type=script&lang=js"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__